import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Award, Shield } from 'lucide-react';

const Hero = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_holiday-lights-pro/artifacts/odn2g9ah_Website_Header_Permanent_Lighting_Saskatoon.webp"
          alt="Beautiful home with permanent lighting"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Saskatoon's Premier Christmas Light Installer
            <span className="text-blue-400 block mt-2">Permanent Holiday Lighting Experts</span>
          </h1>
          <p className="text-xl sm:text-2xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Professional permanent lights installation. We install IllumiDEL, Govee permanent outdoor lights, and premium systems. 20-year warranty on all permanent holiday light installations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              onClick={scrollToQuote}
              size="lg"
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold text-lg px-8 py-6 transition-transform duration-200 hover:scale-105"
            >
              Request a Quote
            </Button>
            <Button
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="border-2 border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-white font-bold text-lg px-8 py-6 transition-all duration-200"
            >
              Explore Services
            </Button>
          </div>

          {/* Feature Pills */}
          <div className="flex flex-wrap gap-6 justify-center">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3">
              <Award className="text-blue-400" size={24} />
              <span className="text-white font-semibold">20-Year Warranty</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3">
              <Sparkles className="text-blue-400" size={24} />
              <span className="text-white font-semibold">Amazing Animations</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3">
              <Shield className="text-blue-400" size={24} />
              <span className="text-white font-semibold">Professional Install</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
